<template>
  <div class="">
    <page-header
      title="Scheduling New Meeting"
      breadcrumb="CRM > Meetings > Schedule New Meeting"
    />

    <div class="card">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold">New Meeting</p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Meeting Type:</label>
            <el-select v-model="meeting.label" placeholder="Select">
              <el-option
                v-for="type in meetingTypes"
                :key="type"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Title:</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Title"
              v-model="meeting.title"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4"></div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Start Date:</label>
            <el-date-picker
              v-model="meeting.startDate"
              type="date"
              placeholder="Pick start date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Start Time:</label>
            <input type="time" class="input" v-model="meeting.startTime" />
          </div>
          <div class="col-12 col-md-6 col-lg-4"></div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">End Date:</label>
            <el-date-picker
              v-model="meeting.endDate"
              type="date"
              placeholder="Pick end date"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">End Time:</label>
            <input type="time" class="input" v-model="meeting.endTime" />
          </div>
          <div class="col-12 col-md-6 col-lg-4"></div>
          <div class="col-12 col-md-12 col-lg-12">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                  <label class="label">External Attendees: </label>
                  <el-select
                    v-model="externalAttendeeId"
                    placeholder="Select"
                    @change="addMeetingContact('external')"
                  >
                    <el-option
                      v-for="contact in contacts"
                      :key="contact.id"
                      :label="contact.name"
                      :value="contact.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap">
              <div
                v-for="(attendee, index) in externalAttendees"
                :key="index"
                class="attendee flex"
              >
                <p>{{ attendee.name }}</p>
                <span
                  class="cursor-pointer pl-4"
                  @click="removeMeetingContact('external', attendee)"
                >
                  X</span
                >
              </div>
            </div>
          </div>

          <!-- <div class="col-12 col-md-6 col-lg-4"></div>
          <div class="col-12 col-md-6 col-lg-4"></div> -->
          <div class="col-12 col-md-12 col-lg-12">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                  <label class="label">Internal Attendees: </label>
                  <el-select
                    v-model="internalAttendeeId"
                    placeholder="Select"
                    @change="addMeetingContact('internal')"
                  >
                    <el-option
                      v-for="contact in contacts"
                      :key="contact.id"
                      :label="contact.name"
                      :value="contact.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap">
              <div
                v-for="(attendee, index) in internalAttendees"
                :key="index"
                class="attendee flex"
              >
                <p>{{ attendee.name }}</p>
                <span
                  class="cursor-pointer pl-4"
                  @click="removeMeetingContact('internal', attendee)"
                >
                  X</span
                >
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Venue:</label>
            <input
              type="text"
              class="input"
              placeholder=""
              v-model="meeting.venue"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Agenda:</label>
            <input
              type="text"
              class="input"
              placeholder=""
              v-model="meeting.description"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Comment:</label>
            <input
              type="text"
              class="input"
              placeholder=""
              v-model="meeting.comment"
            />
          </div>
        </div>
      </div>

      <div class="flex justify-between mt-20 mb-8">
        <div class="cursor-pointer" @click="$router.push({ name: 'Meetings' })">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            :buttonText="`${meeting.id ? 'Update' : 'Schedule'}`"
            :loading="loading"
            @click="scheduleMeeting"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    PageHeader,
  },
  data() {
    return {
      meeting: {
        label: "",
        title: "",
        description: "",
        venue: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        comment: "",
        meetingContacts: [],
      },
      meetingTypes: [
        "product demo",
        "seminar",
        "workshop",
        "presentation",
        "others",
      ],
      contacts: [],
      internalAttendees: [],
      externalAttendees: [],
      internalAttendeeId: "",
      externalAttendeeId: "",
      loading: false,
      meetingId: null,
    };
  },
  watch: {},
  mounted() {
    this.getAllContacts();
    this.meetingId = this.$route.params.id;
    if (this.meetingId) {
      this.getMeetingDetails();
    }
  },
  methods: {
    async scheduleMeeting() {
      if (this.meetingId) {
        this.updateSchedule();
      } else {
        this.loading = true;
        this.meeting.meetingContacts = [
          ...this.internalAttendees,
          ...this.externalAttendees,
        ];
        let payload = {
          payload: {
            ...this.meeting,
          },
        };

        try {
          const response = await this.$_scheduleMeeting(payload);
          this.logResponse(response);
          // this.contacts = response.data.contacts;
          this.generateToast("Meeting scheduled successfully!", "success");
          this.$router.push({ name: "Meetings" });
        } catch (error) {
          this.handleError(error);
        }
        this.loading = false;
      }
    },
    async updateSchedule() {
      this.loading = true;
      this.meeting.meetingContacts = [
        ...this.internalAttendees,
        ...this.externalAttendees,
      ];
      let payload = {
        payload: {
          ...this.meeting,
        },
      };
      try {
        const response = await this.$_updateMeetingSchedule(
          this.meetingId,
          payload
        );
        this.logResponse(response);
        // this.contacts = response.data.contacts;
        this.generateToast("Meeting schedule updated successfully!", "success");
        this.$router.push({ name: "Meetings" });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getMeetingDetails() {
      try {
        const response = await this.$_getSingleMeeting(this.$route.params.id);
        this.logResponse(response);
        this.meeting = response.data;
        console.log(this.meeting);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getAllContacts() {
      try {
        const response = await this.$_getAllContacts();
        this.logResponse(response);
        this.contacts = response.data.contacts;
        if (this.$route.query.contacts) {
          this.savePreselectedContacts();
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    savePreselectedContacts() {
      let selectedContactIds = JSON.parse(localStorage.getItem("contactIds"));
      selectedContactIds.forEach((selectedContactId) => {
        this.contacts.forEach((contact) => {
          if (selectedContactId == contact.id) {
            this.externalAttendeeId = selectedContactId;
            this.addMeetingContact();
          }
        });
      });
    },
    addMeetingContact(attendeeType) {
      let selectedAttendee = null;
      if (attendeeType == "internal") {
        selectedAttendee = this.contacts.filter((contact) => {
          return contact.id == this.internalAttendeeId;
        });
      } else {
        selectedAttendee = this.contacts.filter((contact) => {
          return contact.id == this.externalAttendeeId;
        });
      }
      selectedAttendee = selectedAttendee[0];
      //   console.log(selectedAttendee);
      let contactInfo = {
        name: selectedAttendee.name,
        email: selectedAttendee.email,
        contactId: selectedAttendee.id,
        address: selectedAttendee.address,
        phone: selectedAttendee.phone,
      };
      if (attendeeType == "internal") {
        this.internalAttendees.push(contactInfo);
      } else {
        this.externalAttendees.push(contactInfo);
      }
    },
    removeMeetingContact(attendeeType, attendee) {
      if (attendeeType == "internal") {
        let index = this.internalAttendees.indexOf(attendee);
        this.internalAttendees.splice(index, 1);
      } else {
        let index = this.externalAttendees.indexOf(attendee);
        this.externalAttendees.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped>
.label {
  margin-top: 1.5rem;
}
.input {
  margin-bottom: 0;
}
.attendee {
  background: #f2f7fc;
  border: 0.5px solid #8cafd3;
  box-sizing: border-box;
  border-radius: 3px;
  padding: 0.35rem 0.75rem;
  margin: 0.75rem 1rem 0.75rem 0;
  font-size: 0.8rem;
}
</style>
